import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconUser: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUser"><Path d="M4.5 20.5V19.5C4.5 15.3579 7.85786 12 12 12C16.1421 12 19.5 15.3579 19.5 19.5V20.5H4.5Z" stroke="currentColor"/><Circle cx="12" cy="7.5" r="4.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconUser;
